// To test if the cookie source string matches one of the PR domains
export const prDomainRegex = /((qualitydigest|ien|contractpharma|pharmtech|qualitymag|mddionline|mytechmagazine|mbtmag|mpo-mag|odtmag|industrytoday|cannibisequipmentnews|massdevice|biopharminternational|medicaldesignbriefs|globenewswire)\.com)|(manufacturing\.net)/i;

export function isPrDomain(externalReferrer: string): boolean {
  return prDomainRegex.test(externalReferrer);
}